import React from "react";
import NavigationItem from "./NavigationItem";
import { NAVIGATION_DEMO_2 } from "data/navigation";

function Navigation() {
  return (
    <nav className="nc-Navigation">
      <ul className="flex items-center space-x-1">
        {NAVIGATION_DEMO_2.map((item) => (
          <NavigationItem key={item.id} menuItem={item} />
        ))}
      </ul>
    </nav>
  );
}

export default Navigation;
